import AbstractRouter from './AbstractRouter';
import ClientRoute from './ClientRoute';
import {IClientRoute} from '../../@interfaces/services/Router';
import app from '../../helpers/app';

export default class ClientRouter extends AbstractRouter<IClientRoute> {
    routeConstructor = ClientRoute;

    getRouteByUri(uri: string): IClientRoute | null {
        const url = app('url');

        let matchedRoute = null;
        for (let i = 0; i < this.routes.length; i++) {
            const route = this.routes[i];
            const routeUri = route.getPath();
            if (!routeUri) {
                continue;
            }

            if (uri === routeUri) {
                return route;
            }

            if (!matchedRoute && url.matches(uri, routeUri)) {
                matchedRoute = route;
            }
        }

        return matchedRoute;
    }
}
